export default __webpack_public_path__ + "static/events-dark-349ccae517c7290c4b97e463bab4bac8.png";